export enum DoctorTabName {
  BASIC_DATA = 'BASIC_DATA',
  ADDITIONAL_QUALIFICATIONS = 'ADDITIONAL_QUALIFICATIONS',
  LICENSE = 'LICENSE',
  PRACTICE = 'PRACTICE'
}
